import React from 'react'
import { styled } from '../../../lib/stitches'
import { red5 } from '../../platform/color'

const StyledErrorContainer = styled('div', {
  padding: '16px',
  backgroundColor: red5,
  color: 'white',
  borderRadius: '8px',
  marginBottom: '16px'
})

interface Props {
  errorMessage?: string
}

export const ErrorMessage: React.FC<Props> = ({ errorMessage }) => {
  if (!errorMessage) {
    return null
  }

  return <StyledErrorContainer>{errorMessage}</StyledErrorContainer>
}
